import { useState } from 'react'
import { router } from '@inertiajs/react'

interface ScreenGuideResult {
  open: boolean
  openHelp: () => void
  close: () => void
}

// デモアカウントは単一の共有ユーザーで閲覧専用（PATCH不可）のため、
// 既読管理はDBではなくブラウザ単位のCookieで行う。
const DEMO_SEEN_COOKIE = 'bp_demo_onboarding_seen'

function readDemoSeenScreens (): string[] {
  const match = document.cookie.match(new RegExp(`(?:^|; )${DEMO_SEEN_COOKIE}=([^;]*)`))
  if (match === null) return []
  return decodeURIComponent(match[1]).split(',').filter(Boolean)
}

function markDemoScreenSeen (screenKey: string): void {
  const seen = readDemoSeenScreens()
  if (seen.includes(screenKey)) return
  const next = [...seen, screenKey].join(',')
  document.cookie = `${DEMO_SEEN_COOKIE}=${encodeURIComponent(next)}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`
}

// 画面ガイド（オンボーディング/ヘルプモーダル）の表示状態を管理する。
// 初回アクセス（未読）時は自動で開き、閉じると既読を記録する。既読済みなら自動では開かない。
export function useScreenGuide (screenKey: string, seenScreens: Record<string, string>, isDemo: boolean): ScreenGuideResult {
  const alreadySeen = isDemo ? readDemoSeenScreens().includes(screenKey) : screenKey in seenScreens
  const [open, setOpen] = useState(!alreadySeen)

  function close (): void {
    setOpen(false)
    if (alreadySeen) return

    if (isDemo) {
      markDemoScreenSeen(screenKey)
    } else {
      router.patch('/onboarding_progress', { screen: screenKey }, { preserveScroll: true })
    }
  }

  return { open, openHelp: () => setOpen(true), close }
}
